export default __webpack_public_path__ + "static/media/Flag_of_Armenia.bf875297.svg";